var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"no-feed-wrapper center-xy"},[_c('i',{staticClass:"n-i",class:("n-i-" + _vm.gameId)}),_c('div',{staticClass:"no-feed-message"},[_vm._v(_vm._s(_vm._f("translate")('noOffer')))])])}
var staticRenderFns = []

export { render, staticRenderFns }